import { Box, Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import React from 'react';
import { View } from 'react-native';
import { NumViews } from 'app/design/icons/num-views';
import { NumFavs } from 'app/design/icons/num-favs';
import type { Listing } from 'app/types/listing';
import { createTheme as createDSTheme } from 'app/shopify';
import { useTranslation } from 'react-i18next';
const theme = createDSTheme();

export function ViewsSection({ numViews, numFavourites }: Pick<Listing, 'numViews' | 'numFavourites'>) {
  const { t } = useTranslation('one-listing');
  return (
    <View
      style={{
        backgroundColor: theme.colors['surface.secondary-neutral'],
        borderRadius: theme.borderRadii['radius.xl'],
        paddingHorizontal: 20,
        paddingVertical: 25,
      }}
    >
      <Text fontWeight="600" textAlign="center" variant="headerXSmall">
        {t('viewsSection.title')}
      </Text>

      <Row
        marginTop="spacing.general.x4"
        style={{
          backgroundColor: theme.colors['surface.default'],
          borderRadius: theme.borderRadii['radius.lg'],
          paddingHorizontal: theme.spacing['spacing.general.x4'],
          paddingVertical: theme.spacing['spacing.general.x2'],
        }}
      >
        <Box
          flex={1}
          flexGrow={1}
          paddingLeft={Number.isInteger(numFavourites) ? 'spacing.general.x5' : 'spacing.general.0'}
        >
          <Column alignSelf="center">
            <Text alignSelf="center" fontSize={28} variant="bodyBase">
              {numViews ?? '-'}
            </Text>
            <Row alignItems="center" gap="spacing.general.x0,5">
              <NumViews />
              <Text color="text.secondary" fontSize={13} variant="bodyBase">
                {t('viewsSection.views')}
              </Text>
            </Row>
          </Column>
        </Box>
        {Number.isInteger(numFavourites) && (
          <Box flex={1} flexGrow={1} paddingRight="spacing.general.x5">
            <Column alignSelf="center">
              <Text alignSelf="center" fontSize={28} variant="bodyBase">
                {numFavourites}
              </Text>
              <Row alignItems="center" gap="spacing.general.x0,5">
                <NumFavs />
                <Text color="text.secondary" fontSize={13} variant="bodyBase">
                  {t('viewsSection.favourites')}
                </Text>
              </Row>
            </Column>
          </Box>
        )}
      </Row>
    </View>
  );
}

export function ViewsSectionOthersListings({ numViews }: Pick<Listing, 'numViews'>) {
  if (!Number.isInteger(numViews)) {
    return null;
  }

  return (
    <Row>
      <Text fontWeight="600" textAlign="center" variant="bodyBase">
        👁️ {numViews}
      </Text>
    </Row>
  );
}
